import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const InstallerList = () => import('../views/installer/InstallerList.vue');
const InstallerDemoList = () => import('../views/installer/InstallerDemoList.vue');
const IntranetEdit = () => import('../views/installer/IntranetEdit.vue');

export const installerBasicBreadcrumbs: Breadcrumb[] = [
    {
        label: 'Intranet-Verwaltung',
        href: {name: 'installer-list'},
    },
];

const meta: MetaData = {module: 'installer'};

const installer: RouteRecordRaw[] = [
    {
        path: '/installer',
        redirect: {name: 'installer-list'},
        meta,
    },
    {
        path: '/installer/list/',
        name: 'installer-list',
        component: InstallerList,
        meta,
    },
    {
        path: '/installer/demo/',
        name: 'installer-demo-list',
        component: InstallerDemoList,
        meta,
    },
    {
        path: '/installer/edit/:id/:wildcard*',
        name: 'intranet-edit',
        component: IntranetEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                free: false,
                copy: 0,
            };
        },
        meta,
    },
    {
        path: '/installer/edit-free/:id/:wildcard*',
        name: 'intranet-edit-free',
        component: IntranetEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
                free: true,
                copy: 0,
            };
        },
        meta,
    },
    {
        path: '/installer/add/:copy?',
        name: 'intranet-add',
        component: IntranetEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: 0,
                free: false,
                copy: route.params.copy ? parseInt(route.params.copy) : 0,
            };
        },
        meta,
    },
    {
        path: '/installer/add-free/:copy?',
        name: 'intranet-add-free',
        component: IntranetEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: 0,
                free: true,
                copy: route.params.copy ? parseInt(route.params.copy) : 0,
            };
        },
        meta,
    },
    // COMPATIBILITY: OLD PATHS
    {
        path: '/installer/index/list',
        redirect: {name: 'installer-list'},
        meta,
    },
    {
        path: '/installer/index/edit/id/0',
        redirect: {name: 'intranet-add'},
        meta,
    },
    {
        path: '/installer/index/edit/id/:id',
        redirect: {name: 'intranet-edit'},
        meta,
    },
    {
        path: '/installer/index/edit-free/id/0',
        redirect: {name: 'intranet-add-free'},
        meta,
    },
    {
        path: '/installer/index/edit-free/id/:id',
        redirect: {name: 'intranet-edit-free'},
        meta,
    },
];

export default installer;
